import { render, staticRenderFns } from "./TransactionProductList.vue?vue&type=template&id=b14270b4&"
import script from "./TransactionProductList.vue?vue&type=script&lang=js&"
export * from "./TransactionProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports